import React from "react";
import TableCell from "@material-ui/core/TableCell";
import Slider from "@material-ui/core/Slider";
import { SurveyFormContext } from "../Survey";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  cell: {
    padding: theme.spacing(1, 3, 1, 1),
  },
}));

interface SliderInputProps {
  questionId: number;
  checkedValue: number | null;
  min_value: number;
  max_value: number;
  step: number;
}
const SliderInput: React.FC<SliderInputProps> = (props: SliderInputProps) => {
  const { questionId, checkedValue, min_value, max_value, step } = props;
  const { setAnswerValue } = React.useContext(SurveyFormContext);
  const defaultValue = checkedValue || (min_value + max_value) / 2;

  const classes = useStyles();

  return (
    <TableCell className={classes.cell}>
      <Slider
        track={false}
        color="primary"
        defaultValue={defaultValue}
        min={min_value}
        max={max_value}
        step={step}
        valueLabelDisplay="auto"
        onChangeCommitted={(event: object, value: number | number[]) => {
          setAnswerValue(questionId, Number(value));
        }}
      />
    </TableCell>
  );
};

export default SliderInput;
